export const TSE_TOOL_CODE = 'E360';

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/constants/constants.js